import { useTranslation } from 'next-i18next';
import { cn } from '@zep/utils';
import { serviceShortcuts } from '../../../../consts/landingConsts';
import { ShortcutCard } from './ShortcutCard';
export const LandingShortcut = () => {
  const {
    t
  } = useTranslation(['home']);
  return <section className={cn('w-full', 'py-quiz-2xl tablet:py-quiz-4xl px-quiz-md tablet:px-quiz-2xl', 'flex flex-col gap-quiz-xl tablet:gap-quiz-3xl items-center justify-center')} data-sentry-component="LandingShortcut" data-sentry-source-file="LandingShortcut.tsx">
      <div className="w-full max-w-screen-xl pt-quiz-md">
        <h2 className="text-center text-quiz-heading-lg-extrabold text-quiz-gray-900 tablet:text-quiz-heading-xl-extrabold lg:text-quiz-display-sm-extrabold">
          {t('home:landing.shortcut.title')}
        </h2>
      </div>

      <div className={cn('w-full max-w-[1280px]', 'grid grid-cols-1 tablet:grid-cols-3 gap-quiz-md lg:gap-quiz-lg', 'justify-items-center tablet:justify-items-stretch', 'pb-quiz-lg')}>
        {serviceShortcuts.map(shortcut => <ShortcutCard key={shortcut.id} LogoComponent={shortcut.LogoComponent} title={shortcut.title} url={shortcut.url} imageUrl={shortcut.imageUrl} gradientFrom={shortcut.gradientFrom} gradientTo={shortcut.gradientTo} />)}
      </div>
    </section>;
};